function VisionStatement() {
  return (
    <section className="content-section vision-statement" data-testid="vision-statement-section">
      <span className="section-kicker">The GAMEDAY Genesis</span>
      <div>
        <h2>THE STANDARD ISN’T<br />A DESTINATION. <em>IT’S A SYSTEM.</em></h2>
        <p>GAMEDAY is being developed as an integrated ecosystem where environment, training, recovery, intelligence, and partnership work together. The concepts in this film represent a forward-looking development vision, subject to funding, engineering, regulatory approvals, technology selection, and final design.</p>
      </div>
    </section>
  );
}

const principles = [
  ["performance", "01", "PREPARE", "Build the environments and insight that make deliberate progress possible."],
  ["recovery", "02", "PERFORM", "Bring people, teams, science, and technology together at the moment it matters."],
  ["purpose", "03", "PROGRESS", "Turn learning, resilience, and disciplined collaboration into a durable platform."],
];

function VisionPrinciples() {
  return (
    <section className="vision-principles" data-testid="vision-principles-section">
      {principles.map(([id, number, title, description]) => (
        <article key={id} data-testid={`vision-principle-${id}`}>
          <span>{number}</span>
          <h2>{title}</h2>
          <p>{description}</p>
        </article>
      ))}
    </section>
  );
}

export default function VisionNarrative() {
  return <><VisionStatement /><VisionPrinciples /></>;
}